import { render, staticRenderFns } from "./QuickReply.vue?vue&type=template&id=a2bd1b26&scoped=true&"
import script from "./QuickReply.vue?vue&type=script&lang=js&"
export * from "./QuickReply.vue?vue&type=script&lang=js&"
import style0 from "./QuickReply.vue?vue&type=style&index=0&id=a2bd1b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2bd1b26",
  null
  
)

export default component.exports